const TRANSLATE_MAP = {
  hebrew: {
    tagNames: {
      H1: 'כותרת ראשית',
      H2: 'כותרת משנית',
      H3: 'כותרת רמה 3',
      H4: 'כותרת רמה 4',
      H5: 'כותרת רמה 5',
      H6: 'כותרת רמה 6',
      P: 'פיסקה',
      A: 'קישור',
      IMG: 'תמונה',
      BUTTON: 'כפתור',
      TEXTAREA: 'שדה תיבת טקסט',
      SELECT: 'שדה בחירה מרשימה',
      INPUT: 'שדה',
      LABEL: 'תווית',
      UL: 'רשימה',
      NAV: 'תפריט'
    },
    types: {
      TEXT: 'טקסט',
      DATE: 'תאריך',
      TEL: 'טלפון',
      EMAIL: 'דואר אלקטרוני',
      TIME: 'זמן',
      PASSWORD: 'סיסמא',
      CHECKBOX: 'סימון',
      RADIO: 'בחירה',
      SUBMIT: 'שליחה',
      BUTTON: 'כפתור'
    },
    targets: {
      _BLANK: 'בחלון חדש',
      _SELF: 'בחלון נוכחי'
    }
  }
};

const getElementAttrs = (el) => {
  let attrsObj = {};
  for (let i = 0, atts = el.attributes, n = atts.length, arr = []; i < n; i++){
    for (let att, i = 0, atts = el.attributes, n = atts.length; i < n; i++){
        att = atts[i];
        attrsObj[att.nodeName] = att.nodeValue.toUpperCase();
    }
  }
  return attrsObj;
}

const createTranslatesString = ({ lang, tagName, attrs }) => {
  let translateString = TRANSLATE_MAP[lang]['tagNames'][tagName];
  if (attrs.type) {
    translateString += ' ' + TRANSLATE_MAP[lang]['types'][attrs.type];
  } else if (attrs.target) {
    translateString += ' ' + TRANSLATE_MAP[lang]['targets'][attrs.target];
  }
  return translateString;
}

const translateElementRole = (lang, element) => {
  return createTranslatesString({
    lang: lang, 
    tagName: element.tagName.toUpperCase(),
    attrs: getElementAttrs(element)
  });
}

export { translateElementRole };


// WEBPACK FOOTER //
// ./src/constants/translateElementRole.js